
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Row,} from "reactstrap";
import ContentService from "../../../services/xgContentService";
import HtmlContent from "../util/HtmlContent";
import ShadowWrapper from "../../ShadowWrapper";
import formatFrontendDate from "../util/formatFrontendDate";

class ContentDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contentData: {},
        };
    }

    componentDidMount() {
        const {uniqueId} = this.props.match.params;
        ContentService.fetch(uniqueId).then((response) => {
            this.setState({contentData: response.data});
        });
    }

    render() {
        const {contentData} = this.state;
        return (
            <>
                <SimpleHeader
                    name="Details"
                    parentName="Content"
                    heading="XareGrowth"
                />
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <span className="h3 mb-0">{contentData.title}</span>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols1Input"
                                        >
                                            Title
                                        </label>
                                        <p>{contentData.title}</p>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols3Input"
                                        >
                                            Content Type
                                        </label>
                                        <p>{contentData.contentType}</p>
                                    </FormGroup>
                                </Col>

                                <Col md="4" sm="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example4cols1Input"
                                        >
                                            Article Category
                                        </label>
                                        <p>{contentData.category}</p>
                                    </FormGroup>
                                </Col>
                                <Col md="4" sm="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example4cols3Input"
                                        >
                                            Article Sub Category
                                        </label>
                                        <br/>
                                        {contentData.articleTypes && contentData.articleTypes.map(function (type, index) {
                                            return <h4 key={index} className="badge badge-lg badge-primary">{type}</h4>
                                        })}
                                    </FormGroup>
                                </Col>
                                <Col md="4" sm="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example4cols2Input"
                                        >
                                            Date Created
                                        </label>
                                        <p>{formatFrontendDate(contentData.dateCreated)}</p>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <Button color="default" className="mb-3 sm" outline
                                            onClick={(event) => {
                                                event.preventDefault();
                                                this.props.history.push(`/blog/${contentData.slug}`);
                                            }}
                                    >
                                        View Public Content
                                    </Button>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example4cols2Input"
                                        >
                                            Content Monetization
                                        </label>
                                        <p>{contentData?.isPaidContent ? "PAID" : "FREE"}</p>
                                    </FormGroup>
                                </Col>
                                <Col md="8">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example4cols2Input"
                                        >
                                            SEO Text
                                        </label>
                                        <p>{contentData?.seoText}</p>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols2Input"
                                        >
                                            Content
                                        </label>
                                        <p>
                                            {/*<ShadowWrapper content={contentData.content}/>*/}
                                            <HtmlContent htmlString={contentData.content}/>
                                        </p>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Container>
                <br/>
                <br/>
                <br/>
                <br/>
                {/*<MappingStudentList*/}
                {/*  uniqueId={this.props.match.params.uniqueId}*/}
                {/*  history={this.props.history}*/}
                {/*/>*/}
            </>
        );
    }
}

export default ContentDetails;
